import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { NotificationLevel } from '@shared/services/notification/notification-level.model';
import { SnackbarService } from '@shared/services/notification/snackbar.service';
import { SessionFacade } from '@shared/store/session.facade';
import { SharedRefService } from '@widgets/shared-ref-service/shared-ref-service.service';
import { environment } from 'environments/environment';
import Keycloak from 'keycloak-js';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LogoutIfNotAuthenticatedInterceptor implements HttpInterceptor {
  private readonly matDialog = inject(MatDialog);
  private readonly sessionFacade = inject(SessionFacade);
  private readonly keycloak = inject(Keycloak);
  private readonly sharedReferenceService = inject(SharedRefService);
  private readonly snackbar = inject(SnackbarService);
  private readonly translate = inject(TranslateService);

  readonly ITEM_GW_TOKEN_EXPIRED_MESSAGE = 'Token has expired';

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(
        () => {},
        (err: any) => {
          const currentUserRequest = request.url.indexOf('/current-user') >= 0;
          const chatbotScriptRequest = request.url.indexOf('/chatbot') >= 0;
          if (
            err instanceof HttpErrorResponse &&
            !currentUserRequest &&
            !chatbotScriptRequest &&
            !this.isRequestToCsn(request) &&
            err.status === 401
          ) {
            if (err.error?.message?.includes(this.ITEM_GW_TOKEN_EXPIRED_MESSAGE)) {
              this.showTokenExpiredNotification();
            }
            if (this.keycloak.authenticated) {
              this.closeAllOpenModalsAndOverlays();
              this.sessionFacade.logout();
            }
          }
        }
      )
    );
  }

  private closeAllOpenModalsAndOverlays(): void {
    this.matDialog.closeAll();
    this.sharedReferenceService.closeAllModals();
    this.sharedReferenceService.closeAllOverlays(true);
  }

  private showTokenExpiredNotification() {
    this.snackbar.openSnackbar(
      this.translate.instant('GLOBAL.SESSION_EXPIRED'),
      NotificationLevel.INFO,
      9000
    );
  }

  private isRequestToCsn(request: HttpRequest<any>): boolean {
    if (environment.production) {
      return request.url.includes('csn.vaylens.com');
    }
    if (environment.int) {
      return request.url.includes('csn-int.vaylens.com');
    }
    return request.url.includes('csn-qa.vaylens.com');
  }
}
